export default "__VITE_ASSET__D$hFann5__"